// extracted by mini-css-extract-plugin
export default {"content":"RootView_content__S94Od","feedbackButton":"RootView_feedbackButton__3ZGtL","paywall":"RootView_paywall__GpidG"};